class AbortControllerManager {
  private activeControllers = new Set<AbortController>();

  createController(): AbortController {
    const controller = new AbortController();
    this.activeControllers.add(controller);
    return controller;
  }

  removeController(controller: AbortController): void {
    this.activeControllers.delete(controller);
  }

  abortAll(): void {
    this.activeControllers.forEach((controller) => {
      controller.abort();
    });
    this.activeControllers.clear();
  }

  getActiveCount(): number {
    return this.activeControllers.size;
  }
}

export const abortControllerManager = new AbortControllerManager();
